
import { Box } from "@mui/material";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import styles from "../../styles/layout/DashboardWrapper.module.scss";
import DashBoardHeaderBtm from "../DashBoardHeaderBtm/DashBoardHeaderBtm";

export default function DashboardWrapper({
  children,
  showBtmHeader,
  isList,
  customerID,
  customerSince,
  marketingStatus,
  lastLogIn
}) {

  return (
    <Box className={styles.DashboardWrap}>
      <DashboardHeader />
      {showBtmHeader && (
        <DashBoardHeaderBtm
          showList={isList}
          customerID={customerID}
          customerSince={customerSince}
          marketingStatus={marketingStatus}
          lastLogIn={lastLogIn}
        />
      )}

      <Box
        className={
          showBtmHeader
            ? `${styles.main_body} ${styles.main_body_secnd}`
            : styles.main_body
        }
      >
        {children}
      </Box>
    </Box>
  );
}
